import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { UserService } from './users.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private userService: UserService) { }

  canActivate(): boolean {
    if (this.userService.isTokenExpired()) {
      this.userService.logout();
      return false;
    } else {
      return true;
    }
  }

}
